import { FC } from "react";
import {
    QBD_DESKTOP_EXPORTER_FILENAME,
    qbdDesktopExporterDownloadUrl,
} from "@common/constants/accounting-migration";
import { Button } from "@design-system/Button/Button";
import { DownloadIcon } from "@icons";
import { getEnv } from "@lib/environment";
import styles from "./QbdDesktopExporterDownloadButton.module.scss";

export const QbdDesktopExporterDownloadButton: FC = () => {
    const environment =
        getEnv("KICK_ENV") === "production" ? "production" : "develop";

    return (
        <Button asChild variant="primary" size="sm" className={styles.button}>
            <a
                href={qbdDesktopExporterDownloadUrl(environment)}
                download={QBD_DESKTOP_EXPORTER_FILENAME}
            >
                <DownloadIcon />
                Desktop Exporter
            </a>
        </Button>
    );
};
